
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { WHATSAPP_NUMBER } from "@/constants/portal.constant";
import ModalRequestDemo from "@/components/landing/ModalRequestDemo.vue";

@Component({
  components: {
    ModalRequestDemo,
  },
})
export default class Landing extends Vue {
  @State("locale")
  private locale!: string;

  private isMenuOpen = false;
  private currentLocale = 'en';

  created() {
    this.currentLocale = this.$i18n.locale;
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  private currentSlide = 0;
  private activeCategory: "problem" | "solution" | "results_impact" = "problem";
  private currentSection8Slide = 0;

  private get activeCategoryLabel(): string {
    const labels: Record<string, string> = {
      problem: this.$t("home_problem") as string,
      solution: this.$t("home_solution") as string,
      results_impact: this.$t("home_results_impact") as string,
    };
    return labels[this.activeCategory];
  }

  private get currentSection8(): { img: string; title: string; descriptionKey: string } {
    return this.section8Cards[this.activeCategory][this.currentSection8Slide];
  }

  private get institutionalPartnerRange(): number[] {
    return Array.from({ length: 8 }, (_, i) => i + 1);
  }

  private get schoolPartnerRange(): number[] {
    return Array.from({ length: 7 }, (_, i) => i + 1);
  }

  private get companyPartnerRange(): number[] {
    return Array.from({ length: 7 }, (_, i) => i + 1);
  }

  private section7Cards = [
    { title: "SMK YAJ Depok - Job Fair 2024", img: require("@/assets/Images/section7/8.png") },
    { title: "SMKN 4 Jakarta - Job & Edu Fair 2024", img: require("@/assets/Images/section7/1.png") },
    { title: "SMKN 33 Jakarta - Exploring Tourism Careers", img: require("@/assets/Images/section7/2.png") },
    { title: "SMKN 69 Jakarta - Job Fair Membara 2024", img: require("@/assets/Images/section7/3.png") },
    { title: "SMKS Assalam Depok - Bursa Kerja 2024", img: require("@/assets/Images/section7/4.png") },
    { title: "Universitas Majalengka - UNMA Career Expo 2024", img: require("@/assets/Images/section7/5.png") },
    { title: "SMK Islam PB Soedirman 2 - Career Day 2024", img: require("@/assets/Images/section7/6.png") },
    { title: "SMK Telkom Bandung - Job Fair 2024", img: require("@/assets/Images/section7/7.png") },
  ];

  private section8Cards: Record<string, Array<{ img: string; title: string; descriptionKey: string }>> = {
    problem: [
      { img: require("@/assets/Images/section8/1.png"), title: "SMK Nasional Depok", descriptionKey: "home_s8_problem_0" },
      { img: require("@/assets/Images/section8/2.png"), title: "SMK Prestasi Prima", descriptionKey: "home_s8_problem_1" },
      { img: require("@/assets/Images/section8/3.png"), title: "SMK Islam Malahayati", descriptionKey: "home_s8_problem_2" },
      { img: require("@/assets/Images/section8/4.png"), title: "Universitas Mikroskil", descriptionKey: "home_s8_problem_3" },
    ],
    solution: [
      { img: require("@/assets/Images/section8/1.png"), title: "SMK Nasional Depok", descriptionKey: "home_s8_solution_0" },
      { img: require("@/assets/Images/section8/2.png"), title: "SMK Prestasi Prima", descriptionKey: "home_s8_solution_1" },
      { img: require("@/assets/Images/section8/3.png"), title: "SMK Islam Malahayati", descriptionKey: "home_s8_solution_2" },
      { img: require("@/assets/Images/section8/4.png"), title: "Universitas Mikroskil", descriptionKey: "home_s8_solution_3" },
    ],
    results_impact: [
      { img: require("@/assets/Images/section8/1.png"), title: "SMK Nasional Depok", descriptionKey: "home_s8_results_0" },
      { img: require("@/assets/Images/section8/2.png"), title: "SMK Prestasi Prima", descriptionKey: "home_s8_results_1" },
      { img: require("@/assets/Images/section8/3.png"), title: "SMK Islam Malahayati", descriptionKey: "home_s8_results_2" },
      { img: require("@/assets/Images/section8/4.png"), title: "Universitas Mikroskil", descriptionKey: "home_s8_results_3" },
    ],
  };

  private nextSlide() {
    if (this.currentSlide >= this.section7Cards.length - 1) {
      this.currentSlide = 0;
    } else {
      this.currentSlide++;
    }
  }

  private previousSlide() {
    if (this.currentSlide <= 0) {
      this.currentSlide = this.section7Cards.length - 1;
    } else {
      this.currentSlide--;
    }
  }

  private setCategory(category: "problem" | "solution" | "results_impact") {
    this.activeCategory = category;
    this.currentSection8Slide = 0;
  }

  private nextSection8Slide() {
    const max = this.section8Cards[this.activeCategory].length - 1;
    this.currentSection8Slide = this.currentSection8Slide >= max ? 0 : this.currentSection8Slide + 1;
  }

  private previousSection8Slide() {
    const max = this.section8Cards[this.activeCategory].length - 1;
    this.currentSection8Slide = this.currentSection8Slide <= 0 ? max : this.currentSection8Slide - 1;
  }

  private scrollToSection(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  private getPartnerImage(folder: string, n: number): string {
    return require(`@/assets/Images/${folder}/image_${n}.png`);
  }

  private goToWA() {
    window.open(`https://wa.me/${WHATSAPP_NUMBER.replace("+", "")}`);
  }

  private showAddRequest() {
    this.$bvModal.show("modal-proposal");
  }

  private changeLocale() {
    this.$i18n.locale = this.currentLocale;
    this.$store.commit('mutationLocale', this.currentLocale);
  }

  private toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
